import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  filterBy,
  CompositeFilterDescriptor,
} from "@progress/kendo-data-query";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
} from "@progress/kendo-react-grid";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { LoadingPanel } from "../../components/layout/Loading";
import IconButton from "../../components/common/IconButton";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { MdDelete } from "react-icons/md";
import { closed } from "../../components/muidrawer/muiDrawerSlice";
import { formatIndianNumber } from "../../_helper/helper";

import { setCurrentPage, setPageLimit } from "../pagination/paginationSlice";
import {
  deleteSRExpense,
  getAllSRExpense,
  getSRExpenseByID,
} from "./services/expenseDetails.services";
import {
  setExpenseDetailsGUID,
  setFilterCustomExpenseDetails,
  clearFilterCustomExpenseDetails,
  clearExpenseDetail,
} from "./expenseDetailsSlice";
import { useNavigate } from "react-router-dom";
import _debounce from "lodash/debounce";
import { TextBox } from "@progress/kendo-react-inputs";
import { filterClearIcon } from "@progress/kendo-svg-icons";
import { FiEdit } from "react-icons/fi";
import { FaEye } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import moment from "moment";

const ExpenseDetails: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    return () => {
      dispatch(closeDialog());
      dispatch(closed());
      dispatch(setCurrentPage(0));
      dispatch(clearFilterCustomExpenseDetails());
      dispatch(clearExpenseDetail());
    };
  }, []);

  const handleCreate = () => {
    navigate("/expense/create");
  };

  return (
    <>
      <DeleteSRExpenseDialog />
      <ViewExpenseDetailsDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "20px 20px 20px 0",
          }}
        >
          {/* <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}> */}
          <p className="fs-4" style={{ margin: 0, fontWeight: "bold" }}>
            Expense Details
          </p>
          {/* </Typography.h4> */}
          <Button
            onClick={handleCreate}
            fillMode={"solid"}
            themeColor={"primary"}
          >
            {"Add New"}
          </Button>
        </GridLayoutItem>
        <GridLayoutItem>
          <SRExpenseGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

const SRExpenseGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const FilterCustomExpenseDetails: any = useAppSelector(
    (state) => state.expensedetails.FilterCustomExpenseDetails
  );
  const SRExpenseList = useAppSelector(
    (state) => state.expensedetails.SRExpenseList
  );
  const loading = useAppSelector((state) => state.expensedetails.loading);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };
  const handleExpenseDetailsView = (ID: any) => {
    dispatch(openDialog("viewSRExpenseDetails"));
    dispatch(getSRExpenseByID(ID)).then((res: any) => {
      if (res.meta?.requestStatus === "fulfilled") {
        dispatch(openDialog("viewSRExpenseDetails"));
      }
    });
  };

  useEffect(() => {
    const fetchItemList = async () => {
      const payload = {
        ...FilterCustomExpenseDetails,
        sr_id: Number(localStorage.getItem("UserID")),
        limit: +pageLimit,
        skip: +currentPage * +pageLimit,
      };
      await dispatch(getAllSRExpense(payload));
    };
    fetchItemList();
  }, [currentPage, pageLimit]);

  const MyEditCommandCell = (props: GridCellProps) => {
    const handleOpenDeleteDialog = (expense_details_guid: string) => {
      dispatch(openDialog("deleteSRExpense"));
      dispatch(setExpenseDetailsGUID(expense_details_guid));
    };

    const handleEdit = (id: string) => {
      navigate("/expense/edit", {
        state: {
          expense_details_guid: id,
        },
      });
    };

    return (
      <td
        className="action-td"
        style={{
          ...props.style,
        }}
      >
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Edit"
          disabled={props.dataItem?.verification_status}
          onClick={() => handleEdit(props.dataItem.expense_details_guid)}
        >
          <FiEdit className="absolute-position" style={{ fontSize: "20px" }} />
        </IconButton>
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Delete"
          disabled={props.dataItem?.verification_status}
          onClick={() =>
            handleOpenDeleteDialog(props.dataItem.expense_details_guid)
          }
        >
          <MdDelete
            className="absolute-position"
            style={{ fontSize: "24px" }}
          />
        </IconButton>
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="View"
          onClick={() =>
            handleExpenseDetailsView(props.dataItem?.expense_details_guid)
          }
        >
          <FaEye className="absolute-position" style={{ fontSize: "20px" }} />
        </IconButton>
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
  };
  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className="table-header"
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  // const MyActiveInActtiveCommandCell = (props: GridCellProps) => {
  //   const [IsActive, setIsActive] = useState<boolean>(props.dataItem.isactive);

  //   const handleActiveInActive = () => {
  //     setIsActive(!IsActive);
  //     const data = {
  //       expense_details_guid: props.dataItem.expense_details_guid,
  //       isactive: !IsActive,
  //     };
  //     dispatch(ActiveInactiveExpenseAllocation(data)).then((response: any) => {
  //       const payload = {
  //         limit: +pageLimit,
  //         skip: +currentPage * +pageLimit,
  //       };
  //       if (response.payload?.data?.Status === 200) {
  //         dispatch(getAllExpenseAllocations(payload));
  //       } else {
  //         dispatch(getAllExpenseAllocations(payload));
  //       }
  //     });
  //   };

  //   return (
  //     <td style={{ textAlign: "center" }}>
  //       <Switch
  //         disabled={isEditAccess ? false : true}
  //         name="isactive"
  //         checked={IsActive}
  //         onChange={handleActiveInActive}
  //         size="small"
  //       />
  //     </td>
  //   );
  // };

  if (loading) return <LoadingPanel gridRef={gridRef} />;

  return (
    <>
      <KendoGrid
        style={{ maxHeight: "calc(100vh - 152px)" }}
        className="responsive-table"
        filterable={true}
        filter={filter}
        data={filter ? filterBy(SRExpenseList, filter) : SRExpenseList}
        onFilterChange={handleFilterChange}
        total={SRExpenseList[0]?.itemcount || SRExpenseList?.length}
        skip={currentPage * pageLimit}
        take={pageLimit}
        pageable={{
          buttonCount: 5,
          pageSizes: [10, 50, 100, 300, 500],
          pageSizeValue: pageLimit,
          type: "input",
        }}
        onPageChange={pageChange}
        cells={{
          headerCell: HeaderCustomCell,
          data: MyDataCustomCell,
        }}
      >
        <Column
          width={150}
          field="expense_date"
          filterable={false}
          title="Expense Date"
          cell={(props: any) => (
            <td>
              <div
                className={"hoverableName"}
                onClick={() =>
                  navigate("/expense/edit", {
                    state: {
                      expense_details_guid:
                        props.dataItem?.expense_details_guid,
                    },
                  })
                }
              >
                {props.dataItem?.expense_date}
              </div>
            </td>
          )}
        />
        <Column
          width={200}
          field="from_city_name"
          filterCell={CommonFilterCell}
          title="From City"
        />
        <Column
          width={200}
          field="to_city_name"
          filterCell={CommonFilterCell}
          title="To City"
        />
        <Column
          field="net_amount"
          title="Net Amount"
          filterable={false}
          cell={(props: any) => (
            <td className="text-end">
              {formatIndianNumber(props.dataItem?.net_amount || 0)}
            </td>
          )}
          width={180}
        />

        <Column
          field="disallowed_amount"
          title="Disallowed Amount"
          filterable={false}
          cell={(props: any) => (
            <td className="text-end">
              {formatIndianNumber(props.dataItem?.disallowed_amount || 0)}
            </td>
          )}
          width={180}
        />
        <Column
          field="additional_expense_amount"
          title="Additional Disallowed Amount"
          filterable={false}
          cell={(props: any) => (
            <td className="text-end">
              {formatIndianNumber(
                props.dataItem?.additional_expense_amount || 0
              )}
            </td>
          )}
          width={250}
        />
        <Column
          field="total_amount"
          title="Total Amount"
          filterable={false}
          cell={(props: any) => (
            <td className="text-end">
              {formatIndianNumber(props.dataItem?.total_amount || 0)}
            </td>
          )}
          width={180}
        />
        <Column
          field="verification_status"
          title="Verified Status"
          filterable={false}
          cell={(props: any) => (
            <td className="text-center">
              <div>
                {props.dataItem?.verification_status ? (
                  <span
                    style={{
                      backgroundColor: "#D1FADF",
                      color: "#065032",
                      padding: "3px 10px",
                      textTransform: "capitalize",
                      borderRadius: "10px",
                      fontWeight: "bold",
                    }}
                  >
                    Verified
                  </span>
                ) : (
                  <span
                    style={{
                      backgroundColor: "rgb(254, 240, 199)",
                      color: "rgb(128, 55, 23)",
                      padding: "3px 10px",
                      textTransform: "capitalize",
                      borderRadius: "10px",
                      fontWeight: "bold",
                    }}
                  >
                    Pending
                  </span>
                )}
              </div>
            </td>
          )}
          width={180}
        />
        {/* <Column
            field="id"
            title="Status"
            cell={MyActiveInActtiveCommandCell}
            width={"90px"}
            filterable={false}
            locked={true}
          /> */}

        <Column
          field="id"
          title="Actions"
          cell={MyEditCommandCell}
          width={"150px"}
          filterable={false}
          // locked={true}
        />
      </KendoGrid>
    </>
  );
};

const DeleteSRExpenseDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const ExpenseDetailsGUID = useAppSelector(
    (state) => state.expensedetails.ExpenseDetailsGUID
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const FilterCustomExpenseDetails: any = useAppSelector(
    (state) => state.expensedetails.FilterCustomExpenseDetails
  );

  const handleDeleteAction = async (GUID: string) => {
    if (GUID) {
      const response = await dispatch(deleteSRExpense(GUID));
      const payload = {
        ...FilterCustomExpenseDetails,
        sr_id: Number(localStorage.getItem("UserID")),
        limit: +pageLimit,
        skip: +currentPage * +pageLimit,
      };
      if (response.payload.Data.Status === 200) {
        dispatch(getAllSRExpense(payload));
        dispatch(closeDialog());
        dispatch(setExpenseDetailsGUID(""));
      } else {
        dispatch(getAllSRExpense(payload));
        dispatch(closeDialog());
        dispatch(setExpenseDetailsGUID(""));
      }
    }
  };

  return (
    <>
      {dialogName === "deleteSRExpense" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Expense Details?"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Expense Details?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(ExpenseDetailsGUID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

const CommonFilterCell = (props: any) => {
  const dispatch = useAppDispatch();
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const FilterCustomExpenseDetails: any = useAppSelector(
    (state) => state.expensedetails.FilterCustomExpenseDetails
  );
  const isFilterRef = useRef(true);
  const [inputValue, setInputValue] = useState(props.value || "");
  const [inputField, setInputField] = useState(props.field || "");

  const onChange = (event: any) => {
    setInputValue(event.target.value);
    setInputField(event.target.name);
  };

  const delayedApiCall = React.useCallback(
    _debounce((updatedFilters: any) => {
      dispatch(setCurrentPage(0));
      const payload = {
        ...updatedFilters,
        sr_id: Number(localStorage.getItem("UserID")),
        limit: +pageLimit,
        skip: +currentPage * +pageLimit,
      };

      dispatch(getAllSRExpense(payload));
    }, 300),
    [dispatch]
  );

  useEffect(() => {
    if (!isFilterRef.current) {
      const updatedFilters = {
        ...FilterCustomExpenseDetails,
        [inputField]: inputValue,
      };
      dispatch(setFilterCustomExpenseDetails(updatedFilters));
      delayedApiCall(updatedFilters);
    } else {
      isFilterRef.current = false;
    }
    return () => {
      delayedApiCall.cancel();
    };
  }, [inputValue, delayedApiCall]);

  const onClearButtonClick = (event: any) => {
    event.preventDefault();
    props.onChange({
      value: null,
      operator: "",
      syntheticEvent: event,
    });

    const updatedFilters = { ...FilterCustomExpenseDetails, [props.field]: "" };
    dispatch(setFilterCustomExpenseDetails(updatedFilters));

    const payload = {
      ...updatedFilters,
      sr_id: Number(localStorage.getItem("UserID")),
      limit: +pageLimit,
      skip: +currentPage * +pageLimit,
    };

    dispatch(getAllSRExpense(payload));
  };

  return (
    <div className="d-flex">
      <TextBox
        value={FilterCustomExpenseDetails[props.field] || ""}
        name={props.field || ""}
        onChange={onChange}
      />
      <Button
        svgIcon={filterClearIcon}
        title="Clear"
        disabled={!FilterCustomExpenseDetails[props.field]}
        onClick={onClearButtonClick}
        type="button"
        style={{
          marginLeft: "8px",
        }}
      ></Button>
    </div>
  );
};

const ViewExpenseDetailsDialog: React.FC = () => {
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const loading = useAppSelector((state) => state.expensedetails.loading);
  const ExpenseDetail = useAppSelector(
    (state) => state.expensedetails.ExpenseDetail
  );
  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      {dialogName === "viewSRExpenseDetails" && !loading && (
        <>
          <AppDialog className="expense-details-view-dialog">
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "start",
                }}
              >
                <Typography.h5>Expense Details</Typography.h5>
                <RxCross2
                  onClick={() => {
                    dispatch(closeDialog());
                    dispatch(clearExpenseDetail());
                  }}
                  style={{ fontSize: "25px", fontWeight: "bolder" }}
                />
              </div>
              <div
                style={{
                  height: "500px",
                  overflowY: "scroll",
                  border: "1px solid black",
                  padding: "10px",
                  borderRadius: "4px",
                }}
              >
                <table className="table  table-bordered expense-table">
                  <tbody>
                    <tr>
                      <td style={{ backgroundColor: "lightgrey" }}>
                        <strong>Expense Date</strong>
                      </td>
                      <td>
                        {moment(ExpenseDetail?.expense_date).format(
                          "DD/MM/YYYY"
                        )}
                      </td>
                      <td style={{ backgroundColor: "lightgrey" }}>
                        <strong>Sales Representative</strong>
                      </td>
                      <td>{ExpenseDetail?.sr_name}</td>
                    </tr>
                    <tr>
                      <td style={{ backgroundColor: "lightgrey" }}>
                        <strong>To City</strong>
                      </td>
                      <td>{ExpenseDetail?.to_city_name}</td>
                      <td style={{ backgroundColor: "lightgrey" }}>
                        <strong>From City</strong>
                      </td>
                      <td>{ExpenseDetail?.from_city_name}</td>
                    </tr>
                    <tr>
                      <td style={{ backgroundColor: "lightgrey" }}>
                        <strong>Mode Of Transport</strong>
                      </td>
                      <td>{ExpenseDetail?.mode_of_transport_name}</td>
                      <td style={{ backgroundColor: "lightgrey" }}>
                        <strong>Petrol Allowance</strong>
                      </td>
                      <td className="text-end">
                        {formatIndianNumber(
                          ExpenseDetail?.petrol_rate_per_km || 0
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td
                        rowSpan={2}
                        style={{
                          backgroundColor: "lightgrey",
                          borderBottom: 0,
                        }}
                      >
                        <strong>Cities Visited</strong>
                      </td>
                      <td rowSpan={2} style={{ borderBottom: 0 }}>
                        {ExpenseDetail?.city_town_visisted_name}
                      </td>
                      <td style={{ backgroundColor: "lightgrey" }}>
                        <strong>Fare For Transport</strong>
                      </td>
                      <td className="text-end">
                        {formatIndianNumber(
                          ExpenseDetail?.fare_for_transport || 0
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="expense-for-design-one"></td>
                      <td className="expense-for-design-two"></td>
                      <td style={{ backgroundColor: "lightgrey" }}>
                        <strong>Sales Amount</strong>
                      </td>
                      <td className="text-end">
                        {formatIndianNumber(ExpenseDetail?.sales_amount || 0)}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ backgroundColor: "lightgrey" }}>
                        <strong>Working agent/Area/Town:</strong>
                      </td>
                      <td colSpan={3}>{ExpenseDetail?.remarks}</td>
                    </tr>
                  </tbody>
                </table>

                <Typography.h5>Expenses</Typography.h5>
                <table
                  className="table table-bordered expense-table"
                  // style={{ borderColor: "black" }}
                >
                  <tbody>
                    {ExpenseDetail.expense_details_list.map((item: any) => (
                      <tr>
                        <td style={{ backgroundColor: "lightgrey" }}>
                          <strong>{item?.expense_name?.toUpperCase()}</strong>
                        </td>
                        <td style={{ textAlign: "end" }}>
                          {formatIndianNumber(item.value || 0)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <Typography.h5>Expense Verification</Typography.h5>
                <table className="table table-bordered expense-table">
                  <tbody>
                    <tr>
                      <td style={{ backgroundColor: "lightgrey" }}>
                        <strong>Verified By</strong>
                      </td>
                      <td>{ExpenseDetail.verify_by_name}</td>
                      <td style={{ backgroundColor: "lightgrey" }}>
                        <strong
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          Net Amount <span style={{ color: "green" }}>(A)</span>
                        </strong>{" "}
                      </td>
                      <td style={{ textAlign: "end" }}>
                        {formatIndianNumber(ExpenseDetail.net_amount || 0)}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ backgroundColor: "lightgrey" }}>
                        <strong>Verification Date</strong>
                      </td>
                      <td>
                        {ExpenseDetail?.verification_date
                          ? moment(ExpenseDetail?.verification_date).format(
                              "DD/MM/YYYY"
                            )
                          : ""}
                      </td>
                      <td style={{ backgroundColor: "lightgrey" }}>
                        <strong
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          Disallowed Amount{" "}
                          <span style={{ color: "red" }}>(B)</span>
                        </strong>
                      </td>
                      <td style={{ textAlign: "end" }}>
                        {formatIndianNumber(
                          ExpenseDetail.disallowed_amount || 0
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ backgroundColor: "lightgrey" }}>
                        <strong>Verification Status</strong>
                      </td>
                      <td
                        className={
                          ExpenseDetail?.verification_status
                            ? "text-success"
                            : "text-danger"
                        }
                      >
                        <strong>
                          {ExpenseDetail?.verification_status
                            ? "Verified"
                            : "Not Verified"}
                        </strong>
                      </td>
                      <td style={{ backgroundColor: "lightgrey" }}>
                        <strong
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          Additional Amount{" "}
                          <span style={{ color: "green" }}> (C)</span>
                        </strong>
                      </td>
                      <td style={{ textAlign: "end" }}>
                        {formatIndianNumber(
                          ExpenseDetail.additional_expense_amount || 0
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ backgroundColor: "lightgrey" }}>
                        <strong>Verification Remarks</strong>
                      </td>
                      <td>{ExpenseDetail?.verification_remarks}</td>
                      <td style={{ backgroundColor: "lightgrey" }}>
                        <strong
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          Total Amount
                          <p className="m-0">
                            (<span style={{ color: "green" }}>{"A"}</span> -{" "}
                            <span style={{ color: "red" }}>{"B"}</span> +{" "}
                            <span style={{ color: "green" }}>{"C"}</span>){" "}
                          </p>
                        </strong>
                      </td>
                      <td style={{ textAlign: "end" }}>
                        {formatIndianNumber(ExpenseDetail.total_amount || 0)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          </AppDialog>
        </>
      )}
    </>
  );
};

export default ExpenseDetails;
